import React from 'react';
import { BackgroundProps } from '../../types';
import { useIsMobile } from '../../hooks';
import { BREAKPOINTS } from '../../constants';
import ShaderBackground from './ShaderBackground';

import './Background.css';

import bgGrass from '../../images/bg_grass_light.webp';
import bgGrassDark from '../../images/bg_grass_dark.webp';
import bgWater from '../../images/bg_water_light.webp';
import bgWaterDark from '../../images/bg_water_dark.webp';
import bgSky from '../../images/bg_sky_light.webp';
import bgSkyDark from '../../images/bg_sky_dark.webp';

// Mobile backgrounds
import bgMobileGrass from '../../images/bg_mobile_grass_light.webp';
import bgMobileGrassDark from '../../images/bg_mobile_grass_dark.webp';
import bgMobileWater from '../../images/bg_mobile_water_light.webp';
import bgMobileWaterDark from '../../images/bg_mobile_water_dark.webp';
import bgMobileSky from '../../images/bg_mobile_sky_light.webp';
import bgMobileSkyDark from '../../images/bg_mobile_sky_dark.webp';

const Background: React.FC<BackgroundProps> = ({ mode }) => {
  const isMobile = useIsMobile(BREAKPOINTS.TABLET);

  const isNight = mode === 'night';
  const grassImage = isMobile ? (isNight ? bgMobileGrassDark : bgMobileGrass) : (isNight ? bgGrassDark : bgGrass);
  const waterImage = isMobile ? (isNight ? bgMobileWaterDark : bgMobileWater) : (isNight ? bgWaterDark : bgWater);
  const skyImage = isMobile ? (isNight ? bgMobileSkyDark : bgMobileSky) : (isNight ? bgSkyDark : bgSky);

  return (
    <>
      <div className="parallax-container">
        <div
          id="parallax-layer-1"
          className="parallax-layer"
          style={{ backgroundImage: `url(${grassImage})` }}
        ></div>
        <div
          id="parallax-layer-2"
          className="parallax-layer"
          style={{ backgroundImage: `url(${waterImage})` }}
        ></div>
        <div
          id="parallax-layer-3"
          className="parallax-layer"
          style={{ backgroundImage: `url(${skyImage})` }}
        ></div>
      </div>
      <ShaderBackground mode={mode} isMobile={isMobile} />
    </>
  );
};

export default React.memo(Background);
